import { render, staticRenderFns } from "./FormManifestComponent.vue?vue&type=template&id=2445a7b7&"
import script from "./FormManifestComponent.vue?vue&type=script&lang=js&"
export * from "./FormManifestComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports